export enum PricingPlanEnum {
    basic = 'basic',
    pro = 'pro',
    advanced = 'advanced',
}
